import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Theme } from '../model/theme.model';
import { Observable } from 'rxjs';

@Injectable()
export class ThemeService {
  private httpClient = inject(HttpClient);

  public getTheme(id: string, idp: string): Observable<Theme> {
    return this.httpClient.get<Theme>(`/theme/${idp}`, {
      headers: new HttpHeaders().set('xhr', 'true').set('id', id)
    });
  }
}
